var default_styles_default = {
  "button_container": "QiACx",
  "button_text": "tSx9f",
  "button_size_content": "IwJqB"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
